import React from "react";
import "animate.css";

function Sapauditoverview() {
  return (
    <>
      {/* Responsive Image Styling */}
      <style>
        {`
          @media (max-width: 768px) {
            .sap-audit-img {
              max-height: 350px !important;
            }
          }
        `}
      </style>

      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb5">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            SAP Audit Overview
          </h4>
        </div>
      </div>

      {/* Main Content Start */}
      {/* Main Content Start */}
<div className="container py-5">
  <section className="wow fadeInUp" data-wow-delay="0.2s">
    <div className="section-title text-center mb-5">
      <h2 className="display-6 fw-bold text-primary">
        SAP Audit Overview: Ensuring Success, Security & Compliance
      </h2>
      <p className="text-muted mt-3">
        A comprehensive approach to evaluating your SAP systems for efficiency,
        security, and compliance excellence.
      </p>
    </div>

    {/* Cards Section */}
    <div className="row g-4">
      {/* Post Implementation Audit */}
      <div className="col-lg-4 col-md-6">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 hover-scale">
          <div className="text-center mb-3">
            <i className="fas fa-clipboard-check fa-3x text-primary"></i>
          </div>
          <h4 className="fw-bold text-center mb-3">✅ Post Implementation Audit</h4>
          <p>
            Evaluates the effectiveness of your SAP deployment to ensure it meets
            business goals. Key focus areas include:
          </p>
          <ul className="list-unstyled ms-2">
            <li> Objective validation</li>
            <li> System performance</li>
            <li> User satisfaction</li>
            <li> Risk and compliance</li>
            <li> Cost-benefit analysis</li>
            <li> Continuous improvement</li>
          </ul>
        </div>
      </div>

      {/* SAP Security Audit */}
      <div className="col-lg-4 col-md-6">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 hover-scale">
          <div className="text-center mb-3">
            <i className="fas fa-shield-alt fa-3x text-success"></i>
          </div>
          <h4 className="fw-bold text-center mb-3">🔐 SAP Security Audit</h4>
          <p>
            Assesses your SAP environment’s security posture to identify
            vulnerabilities and ensure compliance. Key benefits:
          </p>
          <ul className="list-unstyled ms-2">
            <li> Risk identification</li>
            <li> Access control review</li>
            <li> Data protection</li>
            <li> SoD issue mitigation</li>
            <li> Incident prevention</li>
            <li> Forensic readiness</li>
          </ul>
        </div>
      </div>

      {/* SAP License Compliance Audit */}
      <div className="col-lg-4 col-md-6">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 hover-scale">
          <div className="text-center mb-3">
            <i className="fas fa-file-contract fa-3x text-warning"></i>
          </div>
          <h4 className="fw-bold text-center mb-3">📜 SAP License Compliance Audit</h4>
          <p>
            Helps manage SAP license usage and avoid costly penalties. Focus areas:
          </p>
          <ul className="list-unstyled ms-2">
            <li>• Actual vs licensed usage</li>
            <li>• Compliance with SAP policies</li>
            <li>• Cost optimization</li>
            <li>• Audit preparedness</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</div>

{/* Hover Animation */}
<style>
  {`
    .hover-scale {
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .hover-scale:hover {
      transform: translateY(-10px);
      box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    }
  `}
</style>


      {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
    </>
  );
}

export default Sapauditoverview;
